import { ProgressCallback } from "../types/ProgressTypes";
import { EupType } from "@carbowaste/excel-sheets-generator/dist/types/models";
import { insertTrialNoticeRow } from "@carbowaste/excel-sheets-generator/dist/sheets/common";
import { doesSheetExist, handleExistingSheetInsertionData, handleNewSheetInsertionData } from "../wrappers/common";
import * as keoAnnualy from "@carbowaste/excel-sheets-generator/dist/sheets/keo/keo_annualy";
import * as keoMonthlyStatement from "@carbowaste/excel-sheets-generator/dist/sheets/keo/keo_monthly_statement";
import * as keoAnnualReportWithPermit from "@carbowaste/excel-sheets-generator/dist/sheets/keo/keo_annual_report_with_permit";
import * as keoCardPrint from "@carbowaste/excel-sheets-generator/dist/sheets/keo/keo_card_print";

export class KEODataFetchWrapper {

    static wrapKeoAnnualDataFetch(
        eupType: EupType,
        year: number,
        sheetName: string
    ) {
        return async (callbacks: ProgressCallback) => {
            try {
                callbacks.onProgress?.("Inicjalizowanie pobierania danych KEO...", 0);

                callbacks.onProgress?.("Pobieranie danych...", 20);
                const matrix = await keoAnnualy.getKeoMatrix(eupType, year);

                callbacks.onProgress?.("Sprawdzanie istniejącego arkusza...", 40);
                const sheetExists = await doesSheetExist(sheetName);
                if (sheetExists) {
                    callbacks.onProgress?.("Arkusz już istnieje, aktualizacja danych...", 60);
                    await handleExistingSheetInsertionData(sheetName);
                    // Nagłówek arkusza
                    await keoAnnualy.firstEightRowsHeader(sheetName, eupType, year);
                } else {
                    callbacks.onProgress?.("Tworzenie nowego arkusza...", 60);
                    await handleNewSheetInsertionData(sheetName);
                    // Nagłówek arkusza
                    await keoAnnualy.firstEightRowsHeader(sheetName, eupType, year);
                }

                if (matrix && matrix.length > 1) {
                    // Naagłówki wierszy
                    await keoAnnualy.addMatrixHeaders(sheetName);
                    callbacks.onProgress?.("Zapisywanie danych do arkusza...", 80);
                    // Wstawianie wartości do arkusza
                    await keoAnnualy.insertMatrixData(sheetName, matrix, eupType);
                    callbacks.onProgress?.("Finalizowanie...", 100);
                    callbacks.onSuccess?.("Raport KEO wygenerowany pomyślnie!");
                } else {
                    // Naagłówki wierszy
                    await keoAnnualy.addMatrixHeaders(sheetName);
                    // Wstawianie wiersza z informacją o braku danych
                    await keoAnnualy.insertNoDataMessage(sheetName, eupType);
                    callbacks.onProgress?.("Finalizowanie...", 100);
                    callbacks.onError?.("Brak danych do wygenerowania raportu KEO");
                }


            } catch (error) {
                callbacks.onError?.(error instanceof Error ? error.message : "Wystąpił błąd podczas generowania raportu KEO");
            }
        };
    }

    static wrapKeoMonthlyStatementDataFetch(
        eupType: EupType,
        year: number,
        sheetName: string
    ) {
        return async (callbacks: ProgressCallback) => {
            try {
                callbacks.onProgress?.("Inicjalizowanie pobierania danych ...", 0);

                callbacks.onProgress?.("Pobieranie danych...", 20);
                //const matrix = []; //await getKeoMatrix(clientId, clientSecret, eupId, year);
                const matrix = await keoMonthlyStatement.getKeoMatrix(eupType, year);

                callbacks.onProgress?.("Sprawdzanie istniejącego arkusza...", 40);
                const sheetExists = await doesSheetExist(sheetName);
                if (sheetExists) {
                    callbacks.onProgress?.("Arkusz już istnieje, aktualizacja danych...", 60);
                    await handleExistingSheetInsertionData(sheetName);
                    // Nagłówek arkusza
                    await keoMonthlyStatement.firstEightRowsHeader(sheetName, eupType, year);
                } else {
                    callbacks.onProgress?.("Tworzenie nowego arkusza...", 60);
                    await handleNewSheetInsertionData(sheetName);
                    // Nagłówek arkusza
                    await keoMonthlyStatement.firstEightRowsHeader(sheetName, eupType, year);
                }

                if (matrix && matrix.length > 1) {
                    // Naagłówki wierszy
                    await keoMonthlyStatement.addMatrixHeaders(sheetName);
                    callbacks.onProgress?.("Zapisywanie danych do arkusza...", 80);
                    // Wstawianie wartości do arkusza
                    await keoMonthlyStatement.insertMatrixData(sheetName, matrix, eupType);
                    callbacks.onProgress?.("Finalizowanie...", 100);
                    callbacks.onSuccess?.("Raport wygenerowany pomyślnie!");
                } else {
                    // Naagłówki wierszy
                    await keoMonthlyStatement.addMatrixHeaders(sheetName);
                    // Wstawianie wiersza z informacją o braku danych
                    await keoMonthlyStatement.insertNoDataMessage(sheetName, eupType);
                    callbacks.onProgress?.("Finalizowanie...", 100);
                    callbacks.onError?.("Brak danych do wygenerowania raportu");
                }


            } catch (error) {
                callbacks.onError?.(error instanceof Error ? error.message : "Wystąpił błąd podczas generowania raportu");
            }
        };
    }

    static wrapKeoAnnualReportWithPermitDataFetch(
        eupType: EupType,
        year: number,
        sheetName: string,
    ) {
        return async (callbacks: ProgressCallback) => {
            try {
                callbacks.onProgress?.("Inicjalizowanie pobierania danych KEO...", 0);

                let overwrite = false;
                let updateMode = false; // Tryb aktualizacji - zachowujemy dane użytkownika

                callbacks.onProgress?.("Pobieranie danych...", 20);
                const matrix = await keoAnnualReportWithPermit.getKeoMatrix(eupType, year);
                callbacks.onProgress?.("Sprawdzanie istniejącego arkusza...", 40);
                const sheetExists = await doesSheetExist(sheetName);
                if (sheetExists) {
                    callbacks.onProgress?.("Arkusz już istnieje, sprawdzam formatowanie...", 60);
                    const isFormatted = await keoAnnualReportWithPermit.isSheetFormattedCorrectly(sheetName);
                    console.log(`KEODataFetchWrapper: Arkusz formatowany poprawnie: ${isFormatted}`);

                    if (!isFormatted) {
                        // Arkusz źle sformatowany - zapytaj użytkownika czy nadpisać
                        const shouldOverwrite = await callbacks.onConfirm?.(
                            `Arkusz "${sheetName}" już istnieje ale nie ma poprawnego formatowania. Czy chcesz go nadpisać? Jezeli tak wówczas wszelkie wartości wpisane dla kolumny "Maksymalnie wg pozwolenia na wytwarzanie odpadów [Mg]" zostaną usunięte`,
                            "Nadpisać arkusz?"
                        );

                        if (!shouldOverwrite) {
                            callbacks.onError?.("Operacja anulowana przez użytkownika");
                            return;
                        }
                        else {
                            overwrite = true; // Nadpisujemy źle sformatowany arkusz
                            await handleExistingSheetInsertionData(sheetName);
                            // Nagłówek arkusza
                            await keoAnnualReportWithPermit.firstEightRowsHeader(sheetName, eupType, year);

                        }
                    } else {
                        // Arkusz poprawnie sformatowany - aktywuj tryb aktualizacji (zachowujemy dane użytkownika)
                        updateMode = true;
                        console.log("KEODataFetchWrapper: Arkusz poprawnie sformatowany, aktywuję tryb aktualizacji");
                    }

                } else {
                    callbacks.onProgress?.("Tworzenie nowego arkusza...", 60);
                    await handleNewSheetInsertionData(sheetName);
                    // Nagłówek arkusza
                    await keoAnnualReportWithPermit.firstEightRowsHeader(sheetName, eupType, year);

                }

                if (matrix && matrix.length > 1) {

                    if (overwrite) {
                        // Nadpisujemy arkusz - generujemy nowy raport (tracimy dane użytkownika)
                        callbacks.onProgress?.("Nadpisywanie arkusza - generowanie nowego raportu...", 70);
                        // Nagłówki wierszy
                        await keoAnnualReportWithPermit.addMatrixHeaders(sheetName);
                        callbacks.onProgress?.("Zapisywanie danych do arkusza...", 80);
                        // Wstawianie wartości do arkusza
                        await keoAnnualReportWithPermit.insertMatrixData(sheetName, matrix, eupType);
                        callbacks.onProgress?.("Finalizowanie...", 100);
                        callbacks.onSuccess?.("Raport wygenerowany pomyślnie!");
                    } else {


                        if (updateMode) {
                            // Tryb aktualizacji - zachowujemy dane użytkownika z kolumny H
                            callbacks.onProgress?.("Aktualizacja raportu - zachowywanie danych użytkownika...", 70);


                            // Aktualizacja danych w arkuszu
                            callbacks.onProgress?.("Aktualizacja danych w arkuszu...", 80);

                            const newWasteCodeList = await keoAnnualReportWithPermit.insertMatrixDataToSheet(sheetName, matrix);
                            console.log(`KEODataFetchWrapper: Wstawiono nowe kody odpadów: ${newWasteCodeList.length}`);
                            if (newWasteCodeList.length > 0) {

                                // Aktualizacja danych użytkownika
                                callbacks.onProgress?.("Zachowanie danych użytkownika zakończone", 85);
                                await keoAnnualReportWithPermit.insertMissingWasteCodes(sheetName, newWasteCodeList, matrix);

                            }
                            // Dodanie Trial Notice dla trybu aktualizacji
                            if (eupType.isTrial) {
                                await Excel.run(async (context) => {
                                    const sheet = context.workbook.worksheets.getItem(sheetName);
                                    // Znajdź ostatni wiersz z danymi w kolumnie A
                                    const maxRows = 1000;
                                    const dataRange = sheet.getRange(`A10:A${9 + maxRows}`);
                                    dataRange.load("values");
                                    await context.sync();

                                    const data = dataRange.values as any[][];
                                    let lastRowWithData = 9; // Domyślnie wiersz 8 (nagłówki)

                                    if (data && data.length > 0) {
                                        for (let rowIndex = data.length - 1; rowIndex >= 0; rowIndex--) {
                                            const value = data[rowIndex]?.[0];
                                            if (value !== null && value !== undefined && value !== "") {
                                                lastRowWithData = rowIndex + 10; // +9 bo zaczynamy od wiersza 9
                                                break;
                                            }
                                        }
                                    }

                                    const trialNoticeRow = lastRowWithData + 2;
                                    await insertTrialNoticeRow(sheet, `A${trialNoticeRow}:H${trialNoticeRow}`, eupType.isTrial);
                                    await context.sync();
                                });
                            }

                            callbacks.onProgress?.("Zapisanie danych w arkuszu...", 90);

                            callbacks.onProgress?.("Finalizowanie...", 100);
                            callbacks.onSuccess?.("Raport uaktualniony z zachowaniem danych użytkownika!");
                        } else {
                            // Tryb nadpisania - tracimy dane użytkownika

                            // Nowy arkusz - generujemy nowy raport
                            callbacks.onProgress?.("Tworzenie nowego raportu...", 70);
                            await keoAnnualReportWithPermit.addMatrixHeaders(sheetName);
                            callbacks.onProgress?.("Zapisanie danych w arkuszu...", 90);
                            await keoAnnualReportWithPermit.insertMatrixData(sheetName, matrix, eupType);
                            callbacks.onProgress?.("Finalizowanie...", 100);
                            callbacks.onSuccess?.("Raport wygenerowany pomyślnie!");
                        }
                    }

                } else {
                    // Nagłówki wierszy
                    await keoAnnualReportWithPermit.addMatrixHeaders(sheetName);
                    // Wstawianie wiersza z informacją o braku danych
                    await keoAnnualReportWithPermit.insertNoDataMessage(sheetName, eupType);
                    callbacks.onProgress?.("Finalizowanie...", 100);
                    callbacks.onError?.("Brak danych do wygenerowania raportu zestawienia rocznego");
                }


            } catch (error) {
                callbacks.onError?.(error instanceof Error ? error.message : "Wystąpił błąd podczas generowania raportu KEO");
            }
        };
    }

    static wrapKeoCardPrintDataFetch(
        eupType: EupType,
        keoCardNumber: string,
        sheetName: string,
    ) {
        return async (callbacks: ProgressCallback) => {
            try {
                callbacks.onProgress?.("Inicjalizowanie pobierania danych KEO...", 0);

                callbacks.onProgress?.("Pobieranie danych...", 20);
                const result = await keoCardPrint.getKeoPrintData(eupType, keoCardNumber);

                callbacks.onProgress?.("Sprawdzanie istniejącego arkusza...", 40);
                const sheetExists = await doesSheetExist(sheetName);
                if (sheetExists) {
                    callbacks.onProgress?.("Arkusz już istnieje, aktualizacja danych...", 60);
                    await handleExistingSheetInsertionData(sheetName);
                } else {
                    callbacks.onProgress?.("Tworzenie nowego arkusza...", 60);
                    await handleNewSheetInsertionData(sheetName);
                }

                // Wstawianie wartości do arkusza
                await keoCardPrint.keoCardPrintSheet(sheetName, eupType);
                await keoCardPrint.insertKeoPrintData(sheetName, result.printData, eupType);

                callbacks.onProgress?.("Finalizowanie...", 100);
                // Przekaż metadata przez onSuccess
                callbacks.onSuccess?.("Raport karty KEO wygenerowany pomyślnie!", result.metadata);

            } catch (error) {
                callbacks.onError?.(error instanceof Error ? error.message : "Wystąpił błąd podczas pobierania danych karty KEO");
            }
        };
    }
}